export default "__VITE_ASSET__BpjQuFZN__"